import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=b3d32f30&"
import script from "./ApproveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports